import { useCallback, useContext, useEffect, useReducer, useRef, useState } from "react";
import { actionConsts, actionConts2, reducer } from "../newComponents/StateManager";
import { HbrArrowLeft, HbrArrowRight, HbrAvatarProfile2, Hbrbackarrow, HbrCancel, HbrCommentIcon, HbrForwardIcon, HbrIconFileCopy, HbrMoreHorizontal, HbrPauseIcon, HbrPlayButton, HbrShareIcon, HbrSoundOff, HbrSoundOn} from "../newComponents/Mycustomsvgicons";
import ReactPlayer from "react-player";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatMediaTime, FormatTimePassedUtc, handleDecreaseEdifiedCount, handleRealtimeDataChanges, sanitizeText } from "../newComponents/GeneralClasses";
import TextShortener from "../TextShortener";
import { arrayRemove, arrayUnion, collection, deleteDoc, doc, getDoc, getDocs, limit, orderBy, query, setDoc, Timestamp, updateDoc, where } from "firebase/firestore";
import db, { realTimeDB } from "../firebase";
import { get, onValue, ref } from "firebase/database";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import UseLayout from "../newComponents/useLayout";
import { AuthContext } from "../AuthContext";
import { addBlogsToDB, deleteEdifiedData, getEdifiedStateDB, initDB, trackEdifiedStateDB } from "../ConfigureIndexDB";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import EdifiedContentList from "../blogcomments/EdifiedContentList";
import { ConstVariables } from "./ConstantVariables";
import edifiedBtn from "../otherImg/newedifiedwhite.png";
import edifiedred from "../otherImg/newedifiedred.png";
import BlogTextShortener from "../Textshortener2";

const BlogVideoPlayer = () => {
    const [videoData, setVideoData]=useState({videolink: "", video_thumb: "",name: "", user_ref: "", desc: "", picture:"", timestamp: 0, index:0, postID: "", edifiedby:[]});
    const [playing,setPlaying]=useState(true);
    const [videos,setVideos]=useState([]);
    const [edifiedList, setEdifiedList]=useState([]);
    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, mute: true, vidBuffering: false, regularUserEdified: false, alertMessage: "", showAlert: false, displayEdifiedList: false, showBottomSheet: false});
    const [played, setPlayed] = useState(0);
    const [trackPlayed, setTrackPlayed] = useState(0);
    const [duration, setDuration] = useState(0);
    const {user_email} = useContext(AuthContext);
    const {userName} = useContext(AuthContext);
    const {verifiedUid} = useContext(AuthContext);
    const [edified,setEdified]=useState(false);
    const [views,setViews]=useState(0);
    const [likes,setLikes]=useState(0);
    const [shareCount, setShareCount] = useState(0);
    const [share,setShare]=useState(false);
    const [copied,setCopied]=useState(false);
    const [openMenu,setOpenMenu]=useState(false);
    const playerRef = useRef(null);
    const {id} = useParams();
    const {width} =UseLayout();
    const navigate = useNavigate();
    const location = useLocation();
    const closeMenuRef = useRef(null);
    const closeShareRef = useRef(null);
    const edifiedRef = useRef(null);
    const now = Timestamp.now();
    const utcTime = new Date(now?.toDate()).toUTCString();




    const getUserPic=(user_ref)=>{
        return new Promise((resolve,reject) => {
            onValue(ref(realTimeDB,`${process.env.REACT_APP_USERS}/${sanitizeText(user_ref)}/profile_pic`),(snapshot)=>{
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                }else{
                    resolve("");
                }
            },(error)=>{
                reject(error);
            });
        });
    };
    const getUserName=(user_ref)=>{
        return new Promise((resolve,reject) => {
            onValue(ref(realTimeDB,`${process.env.REACT_APP_USERS}/${sanitizeText(user_ref)}/userName`),(snapshot)=>{
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                }else{
                    resolve("");
                }
            },(error)=>{
                reject(error);
            });
        });
    };

    useEffect(()=>{
        const docRef = doc(db,"Blog Posts",id);
        getDoc(docRef).then(async(snapshot)=>{
            if (snapshot.exists()) {
                const videoSnapshot = snapshot.data();
                const nameonpost = await getUserName(videoSnapshot?.blogger_email);
                const piconpost = await getUserPic(videoSnapshot?.blogger_email);
                
                setVideoData({
                    index: -1,
                    picture: piconpost,
                    name: nameonpost !== "" ? nameonpost : videoSnapshot?.blogger_name,
                    desc: videoSnapshot?.blog_message,
                    timestamp: videoSnapshot?.timestamp,
                    user_ref: videoSnapshot?.blogger_email,
                    videolink: videoSnapshot?.video_url,
                    postID: videoSnapshot?.postID,
                    edifiedby: videoSnapshot?.edifiedby,
                    video_thumb: videoSnapshot?.video_thumb
                });
            
                // console.log(videoSnapshot.videolink)
                const likesSnapshot = await get(ref(realTimeDB, `Reactions/${videoSnapshot.postID}/edified`));
                if(likesSnapshot.exists()){
                    setLikes(likesSnapshot.val());
                }
        
                const viewsSnapshot = await get(ref(realTimeDB, `Reactions/${videoSnapshot.postID}/views`));
                if(viewsSnapshot.exists()){
                    setViews(viewsSnapshot.val());
                }
        
                const shareSnapshot = await get(ref(realTimeDB, `Reactions/${videoSnapshot.postID}/shares`));
                if(shareSnapshot.exists()){
                    setShareCount(shareSnapshot.val());
                }
            }
        }).catch((err)=>{
            console.log(err);
        });
    },[id]);

    useEffect(()=>{
        const collectionref = collection(db,"Blog Posts");
        const q = query(collectionref,orderBy('timestamp','desc'),limit(70));
        getDocs(q).then((snapshot)=>{
            const blogVideos = [];
            snapshot.forEach((doc)=>{
                blogVideos.push(doc.data());
            });
            const filterVideos = blogVideos.filter(postid => postid.postID !== id && postid.video_url !== "");
           setVideos(filterVideos);
        }).catch((err)=>{
            console.log(err);
        });
    },[id]);

    const handleChangeVideo=async(actionType)=>{
        let index = videoData.index;
        if(actionType === "next"){
            let lastVideo = index === videos.length - 1;
            const nextVid = lastVideo ? 0 : index + 1;
            const nameonpost = await getUserName(videos[nextVid].blogger_email);
            const piconpost = await getUserPic(videos[nextVid].blogger_email);
            if (videos) {
                setVideoData({
                    index: nextVid,
                    picture: piconpost,
                    name: nameonpost !== "" ? nameonpost : videos[nextVid].blogger_name,
                    desc: videos[nextVid].blog_message,
                    timestamp: videos[nextVid].timestamp,
                    user_ref: videos[nextVid].blogger_email,
                    videolink: videos[nextVid].video_url,
                    postID: videos[nextVid].postID,
                    video_thumb: videos[nextVid].video_thumb
                });
            }
        
    
            onValue(ref(realTimeDB, `Reactions/${videos[nextVid].postID}/edified`),(snapshot)=>{
                if(snapshot.exists()){
                    setLikes(snapshot.val());
                }else{
                    setLikes(0);
                }
            });
    
          onValue(ref(realTimeDB, `Reactions/${videos[nextVid].postID}/views`),(snapshot)=>{
                if(snapshot.exists()){
                    setViews(snapshot.val());
                }
          });

          onValue(ref(realTimeDB, `Reactions/${videos[nextVid].postID}/shares`),(snapshot)=>{
                if(snapshot.exists()){
                    setShareCount(snapshot.val());
                }
          });

          handleRealtimeDataChanges(ConstVariables.VIEWS, videos[nextVid].postID);

        }else if(actionType === "prev"){
            let firstVideo = index === 0;
            const prevVideo = firstVideo ? videos.length -1 : index - 1;
            const nameonpost = await getUserName(videos[prevVideo].blogger_email);
            const piconpost = await getUserPic(videos[prevVideo].blogger_email);
            setVideoData({
                index: prevVideo,
                picture: piconpost,
                name: nameonpost !== "" ? nameonpost : videos[prevVideo].blogger_name,
                desc: videos[prevVideo].blog_message,
                timestamp: videos[prevVideo].timestamp,
                user_ref: videos[prevVideo].blogger_email,
                videolink: videos[prevVideo].video_url,
                postID: videos[prevVideo].postID,
                video_thumb: videos[prevVideo].video_thumb
            }); 
    
            onValue(ref(realTimeDB, `Reactions/${videos[prevVideo].postID}/edified`),(snapshot)=>{
                if(snapshot.exists()){
                    setLikes(snapshot.val());
                }else{
                    setLikes(0);
                }
            });
    
          
          onValue(ref(realTimeDB, `Reactions/${videos[prevVideo].postID}/views`),(snapshot)=>{
                if(snapshot.exists()){
                    setViews(snapshot.val());
                }
          });

          onValue(ref(realTimeDB, `Reactions/${videos[prevVideo].postID}/shares`),(snapshot)=>{
                if(snapshot.exists()){
                    setShareCount(snapshot.val());
                }
          });

          handleRealtimeDataChanges(ConstVariables.VIEWS, videos[prevVideo].postID);
        }
        setPlayed(0);
        setDuration(0);
        setTrackPlayed(0);
    };
    const handleEnded=()=>{
        setPlaying(false);
    };
    const handleProgress = (progress) => {
        setPlayed(progress.playedSeconds);
        setTrackPlayed(progress.played);
    };
    const handleDuration = (duration) => {
        setDuration(duration);
    };
    const handleSeekChange = (e) => {
        setTrackPlayed(parseFloat(e.target.value) / duration);
        playerRef.current.seekTo(parseFloat(e.target.value) / duration);
    };
 

    const onBuffering=()=>{
        dispatch({type: actionConsts.VID_BUFFERING, payload: true});
    };
    const onBufferEnd=()=>{
        dispatch({type: actionConsts.VID_BUFFERING, payload: false});
    };

    const closePage=()=>{
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
    };

    const handleVideoMute=(actionType)=>{
        if (actionType === "mute") {
            dispatch({type: actionConsts.MUTE, payload: true});
        }else if (actionType === "unmute") {
            dispatch({type: actionConsts.MUTE, payload: false});   
        }
    };

    const trackEdifiedState =async()=>{
        if(verifiedUid){
            try{
                setEdified(true);
                const docID = `${sanitizeText(user_email)+videoData.postID}`;
                const timestamp = new Date().getTime();
                await updateDoc(doc(db,"Blog Posts",videoData.postID),{
                    edifiedby: arrayUnion(user_email)
                });
                await setDoc(doc(db,"edified souls", docID),{
                    edifiedID: docID,
                    name: userName,
                    display_picture: "",
                    date_reacted: utcTime,
                    post_doc_id: videoData.postID,
                    timestamp
                });
                handleRealtimeDataChanges(ConstVariables.EDIFIED_COUNT, videoData.postID);
            
            }catch{
            }
        }else{
            handleRealtimeDataChanges(ConstVariables.EDIFIED_COUNT, videoData.postID);
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: true});
                //db for keeping regular user edified state data
                await initDB();
                await trackEdifiedStateDB({id: videoData.timestamp, shID: videoData.postID});
        }
        onValue(ref(realTimeDB, `Reactions/${videoData.postID}/edified`),(snapshot)=>{
            if(snapshot.exists()){
                setLikes(snapshot.val());
            }else{
                setLikes(0);
            }
        });
    };

    const removeEdified = async()=>{
            if (verifiedUid) {
                
                try{
                    setEdified(false);
                    const docID = `${sanitizeText(user_email)+videoData.postID}`;
                    await updateDoc(doc(db,"Blog Posts",videoData.postID),{
                        edifiedby: arrayRemove(user_email)
                    });
                    const doc_Ref = doc(db,"edified souls", docID);
                    await deleteDoc(doc_Ref);
                    handleDecreaseEdifiedCount(videoData.postID);
                }catch{
                }
            }else{
                handleDecreaseEdifiedCount(videoData.postID);
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: false});
                await initDB();
                await deleteEdifiedData(videoData.timestamp);
            }
            onValue(ref(realTimeDB, `Reactions/${videoData.postID}/edified`),(snapshot)=>{
                if(snapshot.exists()){
                    setLikes(snapshot.val());
                }else{
                    setLikes(0);
                }
            });
    };

    useEffect(()=>{
        async function getEdifiedStateOfRegularUser() {
            await initDB();
            const res = await getEdifiedStateDB(videoData?.timestamp);
            if (res) {
                res.shID === videoData?.postID ? 
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: true})
                :
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: false});
            }
        }
        getEdifiedStateOfRegularUser();
    },[videoData?.postID, videoData?.timestamp]);

    const handleCopyLink=async()=>{
        if(navigator.clipboard){
            try{
                await navigator.clipboard.writeText(`https://horemowbookreaderlite.web.app/divineblogsvideo/${videoData.postID}`);
                setCopied(true);
                handleRealtimeDataChanges(ConstVariables.SHARES, videoData.postID);
            }catch{
            }
        }
    };

    const handleMoreOptions=async()=>{
        if(navigator.share){
            setShare(false);
            try{
                await navigator.share({
                    text: `Divine blogs (video) by ${videoData.name}\n\n`,
                    url:`https://horemowbookreaderlite.web.app/${videoData.postID}`
                });
            }catch{
            }
        }
    };

    useEffect(()=>{
        if(copied){
            const timeid = setTimeout(() => {
                setCopied(false);
                setShare(false);
           }, 2000);

           return ()=>{
            clearTimeout(timeid);
           }
        }
    },[copied]);

    const handleComments=()=>{
        dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Comment section for video layout is under development"});
        dispatch({type: actionConsts.SHOWALERT, payload: true});
    };

    const handleCloseAlert=useCallback((data)=>{
        if(data === "close"){
            dispatch({type: actionConsts.SHOWALERT, payload: false});
        }
    },[]);

    useEffect(()=>{
        if(share || openMenu){
            const handleCloseShare =(e)=>{
                if (closeShareRef.current) {
                    if(!closeShareRef.current.contains(e.target)){
                        setShare(false);
                    }   
                }
            };
            const handleCloseMenu =(e)=>{
                if (closeMenuRef.current) {
                    try {
                        if(!closeMenuRef.current.contains(e.target)){
                            setOpenMenu(false);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            };
            document.addEventListener('mousedown',handleCloseShare);
            document.addEventListener('mousedown',handleCloseMenu);
            return()=>{
                document.removeEventListener('mousedown',handleCloseShare);
                document.removeEventListener('mousedown',handleCloseMenu);
            }
        }
    },[share, openMenu]);

    useEffect(()=>{
        if (videoData?.edifiedby?.includes(user_email) || state.regularUserEdified) {
            setEdified(true);
        }else{
            setEdified(false);
        }
    },[videoData?.edifiedby, state.regularUserEdified, user_email]);

    const savePost=async()=>{
        await initDB();
         const res = await addBlogsToDB({ id: videoData.postID, blogId: videoData.postID});
         if(res === true){
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: "post is successfully saved"});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
        }
    };

    const handleShowEdifiedList=()=>{
        dispatch({type: actionConsts.DISPLAY_EDIFIED_LIST, payload: true});
        const collectionRef = collection(db,"edified souls");
        const q = query(collectionRef,where("post_doc_id","==",videoData.postID),orderBy("timestamp","desc"));
        getDocs(q).then((snapshot)=>{
            const edifiedDocs = [];
            snapshot.forEach((doc)=>{
                edifiedDocs.push(doc.data());
            });
            setEdifiedList(edifiedDocs);
        }).catch((err)=>{
            console.log(err);
        });
    };

    useEffect(()=>{
        if (state.displayEdifiedList) {
            const closeedifiedlist=(e)=>{
                try {
                    if (edifiedRef) {
                        if(!edifiedRef.current.contains(e.target)){
                          dispatch({type: actionConsts.DISPLAY_EDIFIED_LIST, payload: false});
                        }
                    }
                } catch {
                }
            }
            document.addEventListener('mousedown',closeedifiedlist);
            return () => {
            document.removeEventListener('mousedown',closeedifiedlist);
            }   
        }
    },[state.displayEdifiedList]);

    const handleExpandBlogText=()=>{
        dispatch({type: actionConts2.SHOW_BOTTOMSHEET, payload: true});
    };




    return videoData.videolink && videoData.videolink !== "" ? ( 
        <div className="videobackground" style={{zIndex:"5"}}>

            {state.showAlert && 
                  <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert}/>
            }

                <div className="blogvideoscreen"  onClick={()=>setPlaying(prev => !prev)}>
                    <ReactPlayer
                    ref={playerRef}
                    onProgress={handleProgress}
                    onDuration={handleDuration}
                    onBuffer={onBuffering}
                    onBufferEnd={onBufferEnd}
                    onEnded={handleEnded}
                    playing={playing}
                    width={"100%"} 
                    height={"100%"}
                    muted={state.mute}
                    url={videoData.videolink}
                    />
                </div>

                {state.vidBuffering && <div style={{position:"absolute",top:"50%",left:"45%"}} className="shortsLoader"></div>}

                <div className="seekbarholder2 flex-spacearound">
                    <div className="flex-row2" style={{gap:"10px"}}>
                        {!playing ? (<HbrPlayButton width={"1.6em"} height={"1.6em"} fillColour={"white"} handleClick={()=>setPlaying(true)}/>)
                            : (<HbrPauseIcon width={"1.6em"} height={"1.6em"} fillColour={"white"} handleClick={()=>setPlaying(false)}/>)
                        } 
                         <h4>{formatMediaTime(played)}/{formatMediaTime(duration)}</h4> 
                    </div>
                    
                    <input
                    className="seekbar2"
                    type='range' min={0} max={duration} step='any'
                    value={trackPlayed * duration}
                    onChange={handleSeekChange}/>

                    {state.mute ? <HbrSoundOff width={"1.6em"} height={"1.6em"} fillColour={"white"} handleClick={()=>handleVideoMute("unmute")}/>
                        : <HbrSoundOn width={"1.8em"} height={"1.8em"} fillColour={"white"} handleClick={()=>handleVideoMute("mute")}/>
                    }

                </div>

                <header className="blogvideotop flex-spacearound">
                    <Hbrbackarrow width={"1.8em"} height={"1.8em"} fillColour={"white"} handleClick={()=>closePage()}/>

                    <div className="blogvideodesclayout">
                        <TextShortener 
                        fullText={videoData.desc} 
                        words={width <= 1110 ? 3 : 10} 
                        toggleButtonColor={"white"} 
                        expandAction={handleExpandBlogText} 
                        uniqueClickAction={true}/>
                    </div>
                    
                    {width > 1110 ? 
                        <div className="changevideobuttons flex-row2" style={{gap:"10px"}}>
                              {videoData.index >= 1 && 
                                  <button id="shortsPlayerBtnarrow" onClick={()=>handleChangeVideo("prev")}>
                                      <ArrowBackIos/>
                                  </button>
                              }
                                <button id="shortsPlayerBtnarrow" onClick={()=>handleChangeVideo("next")} >
                                  <ArrowForwardIos/>
                              </button>
      
                              <h4 style={{color:"white",fontWeight:"bold"}}>
                                          {`${Number(videoData.index) + Number(2)}/${videos?.length + 1}`}
                              </h4>
                        </div>
                          :
                          <div className="changevideobuttonsmobile flex-row2" style={{gap:"10px", width:"100%"}}>
                                    {videoData.index >= 1 && 
                                        <div className="shortsplayervidchanger">
                                            <HbrArrowLeft width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={()=>handleChangeVideo("prev")}/>
                                        </div>
                                    }

                                    <div className="shortsplayervidchanger">
                                         <HbrArrowRight width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={()=>handleChangeVideo("next")}/>
                                    </div>
                                    
                                    <div style={{backgroundColor:"#10101050", borderRadius:"30px"}}>
                                        <h4 style={{color:"white",fontWeight:"bold"}}>
                                                    {`${Number(videoData.index) + Number(2)}/${videos?.length + 1}`}
                                        </h4>
                                    </div>
                                 
                        </div>
                    }
              
                    <div className="blogvidcreatorinfo flex-row2">
                        <div className="flex-column2">
                            <h4 style={{color:"white"}}>{videoData.name}</h4>
                            <h4 style={{color:"white",fontWeight:"bold"}}>{FormatTimePassedUtc(videoData.timestamp)}</h4>
                        </div>
                        {videoData.picture !== "" ? 
                            (<img src={videoData.picture} alt="" style={{width:"2.2em",height:"2.2em",borderRadius:"50%",objectFit:"cover"}}/>)
                            :
                            (<HbrAvatarProfile2 width="2.2em" height="2.2em" />)
                        }
                    </div>
                </header>

                <div className={`blogvidreactbuttons ${width <=900 ? 'horizontal':'vertical'}`}>

                    <div className="flex-column2">
                        <h4 style={{color:"white",fontWeight:"bold"}}>Views</h4>
                        <h5 style={{color:"white",fontWeight:"bold"}}>{views && views}</h5>
                    </div>                     

                    <div className="blogvidedifiedimg flex-column2">
                        {edified ?  
                        <img src={edifiedred} alt="" onClick={()=>removeEdified()}/> 
                            :
                        <img src={edifiedBtn} alt="" onClick={()=>trackEdifiedState()}/>
                        }
                        {likes !== 0 &&
                        <h5 style={{color:"white",fontWeight:"bold"}}>{`${likes} edified`}</h5>
                        }
                    </div>

                    <div style={{position:"relative"}}>
                            <div className="flex-column2">
                                <HbrForwardIcon width={"2.2em"} height={"2.2em"} fillColour={"white"} handleClick={() => setShare(true)}/>
                                {shareCount > 0 &&
                                    <div>
                                        <h5 style={{color:"white",fontWeight:"bold"}}>{`${shareCount === 1 ? shareCount + ' share' :  shareCount + ' shares'}`}</h5>
                                    </div>
                                }
                            </div>

                            {share && 
                                <div className="shareform flex-column2" ref={closeShareRef}>

                                        <div className="flex-spacearound" style={{width:"100%",background:"#00000010"}}> 
                                            <h4 style={{width:"80%",overflow:"hidden", color:"white"}}>
                                                {`https://horemowbookreaderlite.web.app/divineshorts/${videoData.postID}`}
                                            </h4>
                                            <HbrIconFileCopy width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleCopyLink()}/>
                                        </div>

                                        <div className="flex-row2">
                                            <h4 style={{color:"white"}}>More options</h4>
                                            <HbrShareIcon width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleMoreOptions()}/>
                                        </div>
                                </div>
                            }

                    </div>

                    <div onClick={()=>handleComments()}>
                        <HbrCommentIcon width="2em" height="2em" fillColour="#ffffff" />
                    </div>

                    <div style={{position:"relative"}}>
                        <HbrMoreHorizontal width="2em" height="2em" fillColour="#ffffff" handleClick={()=>setOpenMenu(prev => !prev)}/> 

                        {openMenu && 
                            <div className="blogvidmenu flex-column2" ref={closeMenuRef}>
                                <button onClick={()=>navigate(`/profilepage?hbruserref=${sanitizeText(videoData.user_ref)}&socialhandle=${videoData.name}`, 
                                {state: {from: location.pathname}})}> 
                                    View Profile
                                </button>
                                <button onClick={()=>savePost()}>Save</button>
                                <button onClick={()=>navigate("/contact",{state: {from: location.pathname}})}>Report</button>
                                <button onClick={()=>handleShowEdifiedList()}>Edified by:</button>
                            </div>
                        }

                            {state.displayEdifiedList &&
                                <div className="blogvidedifiedlistview" ref={edifiedRef}>
                                          <p>List exlude users who prefer to hide their interactive details on a post</p>
                                    {edifiedList && edifiedList.map((data,index)=>(
                                        <EdifiedContentList 
                                            key={index}
                                            personname={data.name}
                                            date_reacted = {data.date_reacted}
                                            display_picture = {data.display_picture}
                                            timestamp = {data.timestamp}
                                        />
                                    ))}
                                </div>
                            }

                    </div>

                </div>

                <div className={`viewBlogTextBottmSheet flex-column1 ${state.showBottomSheet ? 'show':'hide'}`}>
                        <div className="blogtextbottomsheettop flex-spacebetween">
                            <span style={{fontWeight:"bold"}}>{videoData.name}</span>
                            <HbrCancel width={"1.8em"} height={"1.8em"} fillColour={"#000000"} handleClick={()=> dispatch({type: actionConts2.SHOW_BOTTOMSHEET, payload: false})}/>
                        </div>

                        <div className="blog-text-bottomsheet-content">
                            <img src={videoData.video_thumb && videoData.video_thumb} alt="" />
                            <BlogTextShortener fullText={videoData.desc} words={200}/>
                        </div>
                </div>

        </div>
     ):(
        <div style={{position:"relative", backgroundColor:"black", width:"100%", height:"100vh"}}>
            <div style={{position:"absolute",top:"50%",left:"45%"}} className="shortsLoader"></div>
        </div>
     );
}
export default BlogVideoPlayer;